export default "__VITE_ASSET__Ca$F5pjl__"